export enum ComponentType {
  PUBLIC = 'public',
  NEW_PUBLIC = 'new_public',
  REGISTRATION = 'registration',
  LOGIN = 'login',
  AUTHENTICATED = 'authenticated',
  LOGIN_MOBILE = 'login mobile',
}
